import { render } from "./BankAutocomplete.vue?vue&type=template&id=b6b7840e"
import script from "./BankAutocomplete.vue?vue&type=script&lang=js"
export * from "./BankAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__